import { c as _c } from "react/compiler-runtime";
import { Button, Stack, Typography } from '@mui/material';
import { OverflowTooltip } from '../tooltips/overflowTooltip';
export const ChangeableTextField = t0 => {
  const $ = _c(11);
  const {
    value,
    noValueButtonText: t1,
    hasValueButtonText: t2,
    onClick,
    placeholder
  } = t0;
  const noValueButtonText = t1 === undefined ? "Select" : t1;
  const hasValueButtonText = t2 === undefined ? "Change" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      paddingLeft: "20px",
      paddingRight: "12px",
      height: "48px",
      border: "1px solid var(--mui-palette-divider)",
      borderRadius: "4px",
      cursor: "pointer"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== placeholder || $[2] !== value) {
    t4 = value ? <OverflowTooltip text={value} /> : <Typography color="text.disabled">{placeholder}</Typography>;
    $[1] = placeholder;
    $[2] = value;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = value ? "text" : "contained";
  const t6 = value ? hasValueButtonText : noValueButtonText;
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = <Button variant={t5}>{t6}</Button>;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== onClick || $[8] !== t4 || $[9] !== t7) {
    t8 = <Stack direction="row" gap="12px" alignItems="center" justifyContent="space-between" sx={t3} onClick={onClick}>{t4}{t7}</Stack>;
    $[7] = onClick;
    $[8] = t4;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};